<agr-form-dialog [formGroup]="formGroup" [data]="data" (alt)="alt()" (cancel)="cancel()" (confirm)="confirm()">
  <mat-form-field class="full-width-field spacing--padding-top spacing--margin-negative-bottom">
    <mat-label>{{ 'fertilisers-overview.confirmation-dialog-datepicker-placeholder' | translate }}</mat-label>
    <input
      matInput
      formControlName="preferredOrderDate"
      data-test="fertilizerOverviewDialog-preferredOrderDateDatepicker"
      [min]="minDate"
      [max]="maxDate"
      [matDatepickerFilter]="weekendFilter"
      [matDatepicker]="preferredOrderDatePicker"
    />
    <mat-datepicker-toggle matSuffix [for]="preferredOrderDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #preferredOrderDatePicker></mat-datepicker>
  </mat-form-field>
  <mat-list data-test="confirm-order-fertiliser-order-lines-table" class="spacing--margin-negative-all">
    @for (fertiliserOrderplan of data.fertiliserOrderplans; track fertiliserOrderplan) {
      <mat-list-item>
        <mat-icon matListIcon>
          {{ 'store' }}
        </mat-icon>
        <h2 matLine>{{ fertiliserOrderplan.cropAidWithArticles?.name }} &nbsp; ({{ fertiliserOrderplan.cropAidWithArticles?.articleNumber }})</h2>
        <p matLine>
          <span class="text--bold">{{ fertiliserOrderplan.amount | agrNumber }} {{ fertiliserOrderplan.cropAidWithArticles?.unitOfMeasurement }}</span>
        </p>
      </mat-list-item>
    }
  </mat-list>
</agr-form-dialog>
